<template>
  <div class="payment-methods">
    <action-dispatcher action="product/getPaymentMethods">
      <div class="d-flex align-items-center">
        <h4 class="text-semibold">Formas de pagamento *</h4>
      </div>
      <span class="text-dark-40 functional-1">
        Informe como você deseja monetizar o seu
        {{ isEvent ? "evento presencial" : "curso online" }}.
      </span>
      <div v-if="!isEvent" class="alert">
        <bp-icon icon="ph ph-warning-circle fs-18" class="pb-1" />
        <div>
          <div class="fs-14">Atenção</div>
          <div class="text-dark-40 fs-12">
            Caso você tenha configurado um valor em moeda estrangeira, o
            pagamento em Cartão de Crédito será assinalado automaticamente na
            listagem abaixo. Caso configure parcelamento, essa opção estará
            disponível no checkout apenas para compras em Real Brasileiro. Para
            compras internacionais, o checkout exibirá como forma de pagamento
            apenas o Cartão de Crédito à vista.
          </div>
        </div>
      </div>
      <snow-checkbox-group
        v-model="innerValue"
        class="mt-5"
        :options="_paymentMethods"
        @input="updateValue"
      />
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Array
    },
    showForeignInfo: {
      type: Boolean,
      default: false
    },
    isEvent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: [...this.value]
    };
  },
  computed: {
    ...mapState("product", ["paymentMethods"]),
    _paymentMethods() {
      const warnings = {
        2: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque seguindo o prazo configurado para vencimento do boleto.",
        4: "Os pedidos dessa forma de pagamento receberão o status de ‘pendente’ e haverá reserva do estoque por um prazo de 24h."
      };

      const paymentMethods = [
        {
          id: "parceled_billet",
          name: "Boleto Parcelado",
          warning:
            "Ao selecionar Boleto Parcelado as outras opções de pagamento são desativadas."
        },
        ...this.paymentMethods.map(m => ({
          id: m.id,
          name: m.name,
          disabled:
            !!this.innerValue.includes("parceled_billet") ||
            (!!this.showForeignInfo && m.id === 1),
          warning: this.isEvent ? warnings[m.id] : null
        }))
      ];

      const order = [1, 4, 2, 3, 34, "parceled_billet"];

      const orderedPaymentMethods = paymentMethods.sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
      );

      return orderedPaymentMethods;
    }
  },
  methods: {
    updateValue(v) {
      if (v.includes("parceled_billet")) {
        this.innerValue = ["parceled_billet"];
      }
      this.$emit("input", this.innerValue);
    }
  },
  watch: {
    showForeignInfo(v) {
      if (!v) return;

      if (!this.innerValue.includes(1)) this.innerValue.push(1);
      this.$emit("input", this.innerValue);
    }
  }
};
</script>
<style lang="scss">
.payment-methods {
  .alert {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 1rem;
    margin-block: 24px;
    border-radius: 1rem;
    background-color: white;
  }
}
</style>
